<template>
    <div>
        <v-menu
                v-model="menu2"
                :close-on-content-click="false"
                :nudge-right="40"
                transition="scale-transition"
                offset-y
                min-width="290px"
        >
            <template v-slot:activator="{ on, attrs }">
                <v-text-field
                        v-model="dateValue"
                        :label="label"
                        :placeholder="field.ayuda"
                        prepend-icon="mdi-calendar"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                        outlined
                        :error="showError"
                        :error-messages="messageError"

                ></v-text-field>
            </template>
            <v-date-picker
                    v-model="pickerValue"
                    @input="menu2 = false"
                    no-title
                    locale="es-mx"
                    :readonly="readonly"
                    :max="getMaxDate()"
                    :min="getMinDate()"
            ></v-date-picker>
        </v-menu>
    </div>
</template>

<script>
    import moment from 'moment'

    export default {
        name: "Date",
        props: ['field', 'readonly', 'label', 'formValues'],
        data(){
            return {
                menu2: false,
                pickerValue: null,
                showError: false,
                messageError: "",

                localValue: null,
                localValueIsReady: false
            }
        },

        computed: {
            dateValue: {
                get(){
                    if (this.formValues[this.field.nombre]){
                        this.initDateAndPickerValue()
                    }

                    return this.localValue;
                },

                // eslint-disable-next-line no-unused-vars
                set(newValue){
                    this.formValues[this.field.nombre] = newValue
                }
            }
        },

        watch: {
            pickerValue(){
                if (this.field.extra.data_format && this.field.extra.data_format != ''){
                    this.formValues[this.field.nombre] =
                        moment(this.pickerValue).format('YYYY-MM-DD')

                    if (!this.localValueIsReady){
                        this.localValue =
                            moment(this.pickerValue).format(this.getFieldFormat())
                    }
                }else {
                    this.formValues[this.field.nombre] = this.pickerValue
                }
            }
        },
        methods: {
            initDateAndPickerValue(){
                this.localValueIsReady = false

                if (this.formValues[this.field.nombre]){
                    let dateMoment = moment(this.formValues[this.field.nombre], this.getFieldFormat(), true)

                    if (!dateMoment.isValid()){
                        let tryParseMoment = moment(this.formValues[this.field.nombre], 'YYYY-MM-DD', true)

                        if (tryParseMoment.isValid()){
                            this.localValueIsReady = true
                            this.localValue = tryParseMoment.format(this.getFieldFormat())
                        }else{
                            this.messageError = `Error en el formato de la fecha (${this.formValues[this.field.nombre]})`
                            this.formValues[this.field.nombre] = null
                            this.localValue = null
                            this.showError = true
                        }
                    }else{
                        this.localValueIsReady = true
                        this.localValue = dateMoment.format(this.getFieldFormat())
                        this.formValues[this.field.nombre] = dateMoment.format('YYYY-MM-DD')
                    }
                }

                this.pickerValue = this.getPickerValue()
            },

            getMaxDate(){
                return this.field.extra.validateDate && this.field.extra.validateDate == 1 && this.field.extra.valid_date == 'past_date' ?
                    (new Date().toISOString()) : ''
            },

            getMinDate(){
                return this.field.extra.validateDate && this.field.extra.validateDate == 1 && this.field.extra.valid_date == 'future_date' ?
                    (new Date().toISOString()) : ''
            },

            getPickerValue(){
                let value = this.formValues[this.field.nombre]
                if (value != null && value!= '' && this.field.extra.data_format && this.field.extra.data_format != ''){
                    return moment(this.formValues[this.field.nombre], 'YYYY-MM-DD').format()
                }

                console.log(this.formValues[this.field.nombre])
                console.log(this.localValue)

                return this.formValues[this.field.nombre]
            },

            getFieldFormat(){
                let format = this.field.extra.data_format.toUpperCase()
                    .replace('YY', 'YYYY')

                return format
            }
        }
    }
</script>